// FILE: src/services/assets.js (FULLY UPDATED)

import axios from 'axios';
import { message } from 'antd';
import axiosServices from './axios';
import { REACT_APP_GOOGLE_FONT } from '../config'; // Import the key from your config

export const uploadOnboardingAsset = async (file, brandName, groupId) => {
  console.log(`[Service uploadOnboardingAsset] Uploading file for brand: ${brandName}`);
  if (!file) {
    throw new Error("No file selected for upload.");
  }
  if (!brandName) {
    throw new Error("Brand name is required for onboarding uploads.");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("brandName", brandName);
  if (groupId) {
    formData.append("groupId", groupId);
  }

  try {
    const response = await axiosServices.post("/single-upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("[Service uploadOnboardingAsset] Upload response:", response.data);
    return response.data;
  } catch (error) {
    console.error("[Service uploadOnboardingAsset] Error:", error);
    if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
        const limitError = new Error(error.response.data.message);
        limitError.isLimitError = true;
        limitError.feature = 'Media Storage';
        throw limitError;
    }
    throw error;
  }
};

export const uploadAssetService = async (file, groupId, onUploadProgress) => {
    console.log(`[Service uploadAssetService] Uploading file for groupId: ${groupId}`);
    if (!file) {
        throw new Error("No file selected for upload.");
    }
    if (!groupId) {
        throw new Error("Group context is required for upload.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("groupId", groupId);

    try {
        const uploadResponse = await axiosServices.post("/single-upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress
        });

        console.log("[Service uploadAssetService] File uploaded to Azure, response:", uploadResponse.data);

        if (!uploadResponse?.data?.url) {
            throw new Error("File upload service did not return a valid URL.");
        }
        
        console.log("[Service uploadAssetService] Asset registered in DB successfully.");
        return uploadResponse.data;

    } catch (error) {
        if (error.response?.status === 403 && error.response?.data?.errorType === 'LIMIT_REACHED') {
            const limitError = new Error(error.response.data.message);
            limitError.isLimitError = true;
            limitError.feature = 'Media Storage';
            throw limitError;
        }
        const errorMessage = error.response?.data?.message || 'Asset upload and registration failed.';
        console.error("[Service uploadAssetService] Error:", errorMessage);
        throw new Error(errorMessage);
    }
};

export const getGoogleFonts = async (setFontList, setSelectedFont, setBodySelectedFont) => {
    const apiKey = REACT_APP_GOOGLE_FONT; // Use the imported key

    if (!apiKey) {
        const errorMsg = "CRITICAL: Google Fonts API Key is not defined in your .env file.";
        message.error(errorMsg);
        console.error(errorMsg);
        return;
    }

    try {
        const response = await axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}`);
        const fontList = response.data.items.map(item => item.family);
        setFontList(fontList);
        if (setSelectedFont) setSelectedFont(fontList[0] || "Roboto");
        if (setBodySelectedFont) setBodySelectedFont(fontList[0] || "Roboto");
    } catch (error) {
        message.error('Failed to fetch fonts. Please check API key restrictions in Google Cloud Console.');
        console.error("Google Fonts API Error:", error);
    }
};

export const uploadBrandAssets = async (data) => {
    try {
        await axiosServices.patch(`/onboarding/add-onboarding3`, data);
    } catch (error) {
        console.error(error);
        throw new Error('Error submitting brand assets');
    }
};

export const generateUniqueID = async (setUniqueID) => {
    try {
        const response = await axiosServices.get(`/unique/generate-id`);
        setUniqueID(response.data.id);
    } catch (error) {
        console.error(error);
        message.error('Error generating unique ID');
    }
};

export const updateUserStatus = async () => {
    try {
        await axiosServices.patch(`/user/update-status`, { status: 'completed' });
    } catch (error) {
        console.error(error);
        message.error('Error updating user status');
    }
};